import { MeterCounter } from '@epilot/metering-client'

export const MOCK_METER_COUNTER_DETAILS = [
  {
    obis_number: '1-0:1.8.0',
    direction: 'feed-out',
    unit: 'kWh',
    _tags: ['dont-touch'],
    _schema: 'meter_counter',
    _id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
    _org: 'test-org',
    _created_at: '2025-04-22T09:08:09.146Z',
    _updated_at: '2025-05-23T06:10:07.956Z',
    _title: '1-0:1.8.0',
    tariff_type: 'et',
    transformer_ratio: '10',
    conversion_factor: '0.01'
  }
]

export const MOCK_METER_COUNTER_DETAIL: { data: MeterCounter } = {
  data: {
    obis_number: 'ABCD1234567890',
    direction: 'feed-out',
    tariff_type: 'nt',
    unit: 'kWh',
    _tags: [],
    _schema: 'meter_counter',
    _id: '1eb32c20-9747-4f01-88ca-0a5c2f0b49c2',
    _org: 'test-org',
    _created_at: '2023-11-28T10:49:42.914Z',
    _updated_at: '2024-09-27T13:10:45.658Z',
    _title: 'Zählwerk'
  }
}
